import { render } from "./Create.vue?vue&type=template&id=4bd47082"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Contacts/Create.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4bd47082"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4bd47082', __exports__)) {
    console.log('reload')
    api.reload('4bd47082', __exports__)
  }
  
  module.hot.accept("./Create.vue?vue&type=template&id=4bd47082", () => {
    console.log('re-render')
    api.rerender('4bd47082', render)
  })

}


export default __exports__